import { NotFound } from "@dgs/core";
import { FC } from "react";
import { Navigate, Route, Routes } from "react-router";
import { FilterProvider } from "../../../shared/filters";
import { applicationService } from "../shared/api/applicationService";
import { ApplicationList } from "./ApplicationList";
import { ApplicationUserList } from "./ApplicationUserList";

export const ApplicationPage: FC = () => {
	return (
		<FilterProvider entity="APPLICATION" keysToInvalidate={[applicationService.keys.index]}>
			<Routes>
				<Route index={true} element={<Navigate to="overview" />} />
				<Route path="overview" element={<ApplicationList />} />
				<Route path=":applicationId/users" element={<ApplicationUserList />} />
				<Route path="*" element={<NotFound />} />
			</Routes>
		</FilterProvider>
	);
};
